import { reishauerNachtschichtReadableId } from './../../../environments/environment';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';

export interface OrderTypeSelection {
	id: string;
	readableId: any;
	name: {
		de: string;
		en: string;
	};
	icon: string;
	description?: string;
}

@Component({
	selector: 'app-order-type-selection',
	templateUrl: './order-type-selection.component.html',
	styleUrls: ['./order-type-selection.component.scss'],
})
export class OrderTypeSelectionComponent implements OnInit {
	@Output() orderTypeSelected = new EventEmitter<OrderTypeSelection>();
	@Output() backPressed = new EventEmitter<void>();

	selectedOrderType: OrderTypeSelection | null = null;
	currentLanguage: string = '';

	orderTypes: OrderTypeSelection[] = [
		{
			id: 'night-shift',
			readableId: environment.reishauerNachtschichtReadableId,
			name: {
				de: 'Nachtschicht',
				en: 'Night shift',
			},
			icon: 'moon',
			description: 'Bestellung für die Nachtschicht',
		},
		{
			id: 'meeting-room',
			readableId: environment.reishauerMeetingraumReadableId,
			name: {
				de: 'Meeting Raum',
				en: 'Meeting room',
			},
			icon: 'restaurant',
			description: 'Bestellung für den Meeting Raum',
		},
	];

	// Payment methods displayed at bottom
	paymentMethods = [
		{
			name: 'Visa',
			icon: 'assets/icon/visa-logo.png',
			alt: 'Visa',
		},
		{
			name: 'Mastercard',
			icon: 'assets/icon/mastercard-logo.png',
			alt: 'Mastercard',
		},
		{
			name: 'Twint',
			icon: 'assets/icon/twint-logo.png',
			alt: 'Twint',
			class: 'twint',
		},
	];

	constructor(private router: Router, private translate: TranslateService, private repository: RepositoryService) {}

	ngOnInit() {
		this.currentLanguage = this.translate.currentLang;
	}

	onSelectOrderType(orderType: OrderTypeSelection) {
		this.selectedOrderType = orderType;
		this.orderTypeSelected.emit(orderType);
		localStorage.setItem('orderTypeId', this.selectedOrderType.id);

		// Navigation is now handled by parent component
		// Add slight delay for visual feedback
		setTimeout(() => {
			// Visual feedback complete - parent handles navigation
		}, 500);
	}

	isSelected(orderType: OrderTypeSelection): boolean {
		return this.selectedOrderType?.id === orderType.id;
	}

	// Get icon name for Ionic icons
	getIconName(iconType: string): string {
		switch (iconType) {
			case 'moon':
				return 'moon-outline';
			case 'restaurant':
				return 'restaurant-outline';
			default:
				return 'help-outline';
		}
	}

	async goToExternalLink() {
		try {
			const nachtschichtVenue = await this.findVenue();

			if (nachtschichtVenue && nachtschichtVenue.nutritionTable) {
				open(nachtschichtVenue.nutritionTable, '_blank');
			} else {
				// Fallback to the default URL if venue data is not available
				open('https://storage.googleapis.com/smoothr-images-prod/reishauer/nutrition-table.pdf', '_blank');
			}
		} catch (error) {
			console.error('Error loading venue data:', error);
			// Fallback to the default URL if there's an error
			open('https://storage.googleapis.com/smoothr-images-prod/reishauer/nutrition-table.pdf', '_blank');
		}
	}

	goToBusinessRoomReservation() {
		open('https://www.lunchgate.ch/restaurant/personalrestaurant-reishauer-wallisellen/', '_blank');
	}

	async goToRoomOverview() {
		const nachtschichtVenue = await this.findVenue();
		open('https://storage.googleapis.com/smoothr-pdf/reishauer/meeting-room.pdf', '_blank');
	}

	private async findVenue() {
		const venues = await this.repository.getAllVenues(environment.customerGroup);
		const nachtschichtVenue = venues.find(venue => venue.readableId === environment.reishauerNachtschichtReadableId);

		return nachtschichtVenue;
	}

	// onBack() {
	//   this.backPressed.emit();
	// }
}
